export default {
    namespaced: true,
    // -----------------------------------------------------------------
    state: {
        schedule: {
            location: null,
            location_type: "WORDPRESS",
            radius: null,
            date_object: null,
            shares: [],
            attendee_object: {
                type: "exact",
                data: {
                    amount: 10
                }
            },
            activities: [],
            gifts: []
        },
        pageLoading: false,
        externalActivitiesLoaded: false,
        externalActivities: [],
        translations: null
    },
    // -----------------------------------------------------------------
    getters: {
        schedule: state => {
            return state.schedule;
        },
        translations: state => {
            return state.translations;
        },
        externalActivities: state => {
            return state.externalActivities;
        },
        externalActivitiesLoaded: state => {
            return state.externalActivitiesLoaded;
        },
        pageLoading: state => {
            return state.pageLoading;
        }
    },
    // -----------------------------------------------------------------
    mutations: {
        SET_SCHEDULE(state, schedule) {
            state.schedule = schedule;
        },
        SET_PAGELOADING(state, loading) {
            state.pageLoading = loading;
        },
        SET_SCHEDULE_LOCATION(state, location) {
            state.schedule.location = location;
        },
        SET_SCHEDULE_RADIUS(state, radius) {
            state.schedule.radius = radius;
        },
        SET_SCHEDULE_DATE(state, date_object) {
            state.schedule.date_object = date_object;
        },
        SET_SCHEDULE_ATTENDEES(state, attendee_object) {
            state.schedule.attendee_object = attendee_object;
        },
        SET_SCHEDULE_LOCATION_DATA(state, location_data) {
            state.schedule.location = location_data.location;
            state.schedule.location_type = location_data.location_type;
            state.schedule.radius = location_data.radius;
        },
        ADD_SCHEDULE_ACTIVITY(state, activity_object) {
            state.schedule.activities.push(activity_object);
        },
        ADD_SCHEDULE_ACTIVITIES(state, activity_objects) {
            for (let i = 0; i < activity_objects.length; i++) {
                state.schedule.activities.push(activity_objects[i]);
            }
        },
        DELETE_SCHEDULE_ACTIVITY(state, activity_index) {
            state.schedule.activities.splice(activity_index, 1);
        },
        DELETE_SCHEDULE_ACTIVITIES(state, activity_indexes) {
            for (let i = 0; i < activity_indexes.length; i++) {
                state.schedule.activities.splice(activity_indexes[i], 1);
            }
        },
        UPDATE_SCHEDULE_ACTIVITY(state, { activity_index, activity_object }) {
            state.schedule.activities[activity_index] = activity_object;
        },
        SET_SCHEDULE_ACTIVITY_REQUEST(state, { activity_index, value }) {
            state.schedule.activities[activity_index].data.has_requests = value;
        },
        SET_GIFT(state, gift_object) {
            state.schedule.gifts = [];
            state.schedule.gifts.push(gift_object);
        },
        ADD_GIFT(state, gift_object) {
            state.schedule.gifts.push(gift_object);
        },
        DELETE_GIFT(state, gift_index) {
            state.schedule.gifts.splice(gift_index, 1);
        },
        SET_EXTERNALACTIVITIES(state, externalActivities) {
            state.externalActivities = externalActivities;
            state.externalActivitiesLoaded = true;
        },
        ADD_EXTERNALACTIVITY(state, payload) {
            state.externalActivitiesLoaded = true;
            state.externalActivities.push(payload);
        },
        SET_TRANSLATIONS(state, translations) {
            state.translations = translations;
        },
        UPDATE_SHARES(state, payload) {
            state.schedule.shares = payload;
        }
    },
    // -----------------------------------------------------------------
    actions: {
        setPageLoading(context, loading) {
            context.commit("SET_PAGELOADING", loading);
        },
        setLocation(context, location) {
            context.commit("SET_SCHEDULE_LOCATION", location);
        },
        setRadius(context, radius) {
            context.commit("SET_SCHEDULE_RADIUS", radius);
        },
        setDateObject(context, date_object) {
            context.commit("SET_SCHEDULE_DATE", date_object);
        },
        setAttendeeObject(context, attendee_object) {
            context.commit("SET_SCHEDULE_ATTENDEES", attendee_object);
        },
        setlocationData(context, location_data) {
            context.commit("SET_SCHEDULE_LOCATION_DATA", location_data);
        },
        addActivity(context, activity_object) {
            context.commit("ADD_SCHEDULE_ACTIVITY", activity_object);
        },
        addActivities(context, activity_objects) {
            context.commit("ADD_SCHEDULE_ACTIVITIES", activity_objects);
        },
        deleteActivity(context, activity_index) {
            context.commit("DELETE_SCHEDULE_ACTIVITY", activity_index);
        },
        deleteActivities(context, activity_indexes) {
            context.commit("DELETE_SCHEDULE_ACTIVITIES", activity_indexes);
        },
        updateActivity(context, { activity_index, activity_object }) {
            context.commit("UPDATE_SCHEDULE_ACTIVITY", {
                activity_index,
                activity_object
            });
        },
        setActivityRequest(context, { activity_index, value }) {
            context.commit("SET_SCHEDULE_ACTIVITY_REQUEST", {
                activity_index,
                value
            });
        },
        updateShares(context, payload) {
            context.commit("UPDATE_SHARES", payload);
        },
        addGift(context, gift_object) {
            context.commit("ADD_GIFT", gift_object);
        },
        deleteGift(context, gift_index) {
            context.commit("DELETE_GIFT", gift_index);
        },
        addExternalActivity(context, payload) {
            context.commit("ADD_EXTERNALACTIVITY", payload);
        },
        readExternalActivities(context, activities) {
            return axios
                .get(
                    route(
                        "get-external-activities",
                        activities.filter(a => a.type === "listed")
                    )
                )
                .then(response => {
                    context.commit("SET_EXTERNALACTIVITIES", response.data);
                    return response.data;
                });
        },
        create(context, schedule) {
            const fd = prepareFormData(schedule);
            return axios.post(route("create-schedule"), fd).then(response => {
                context.commit("SET_SCHEDULE", response.data.data);
                return response.data.data;
            });
        },
        read(context, id) {
            return axios
                .get(route("read-schedule", { id: id }))
                .then(response => {
                    context.commit("SET_SCHEDULE", response.data.data);
                    return response.data.data;
                });
        },
        readPublic(context, publicKey) {
            return axios
                .get(route("read-public-schedule", { publicKey: publicKey }))
                .then(response => {
                    context.commit("SET_SCHEDULE", response.data.data);
                    return response.data.data;
                });
        },
        update(context, { schedule, set }) {
            const fd = prepareFormData(schedule);
            fd.append("_method", "PUT");

            return axios
                .post(route("update-schedule", schedule.id), fd)
                .then(response => {
                    if (set) context.commit("SET_SCHEDULE", response.data.data);
                    return response.data.data;
                });
        },
        updatePublic(context, schedule) {
            const fd = prepareFormData(schedule);
            fd.append("_method", "PUT");

            return axios
                .post(
                    route("update-public-schedule", {
                        publicKey: schedule.public_key
                    }),
                    fd
                )
                .then(response => {
                    context.commit("SET_SCHEDULE", response.data.data);
                    return response.data.data;
                });
        },
        duplicate(context, schedule) {
            return axios
                .post(route("duplicate-schedule", { id: schedule.id }))
                .then(response => {
                    context.commit("SET_SCHEDULE", response.data.data);
                    return response.data.data;
                });
        },
        duplicatePublic(context, schedule) {
            return axios
                .post(route("duplicate-schedule", { id: schedule.public_key }))
                .then(response => {
                    context.commit("SET_SCHEDULE", response.data.data);
                    return response.data.data;
                });
        },
        initTranslations(context, translations) {
            context.commit("SET_TRANSLATIONS", translations);
        }
    }
};

function prepareFormData(schedule) {
    const fd = new FormData();

    if (schedule.location_type) {
        fd.append("location_type", schedule.location_type);

        if (schedule.location) {
            if (schedule.location_type === "WORDPRESS") {
                fd.append("location", schedule.location.post_title ? schedule.location.post_title : schedule.location);
            } else if (schedule.location_type === "GOOGLE_MAPS") {
                fd.append("location", schedule.location);
            }
        }

        if (schedule.radius) {
            fd.append("radius", schedule.radius);
        }
    }

    if (schedule.shares) {
        for (let i = 0; i < schedule.shares.length; i++) {
            fd.append(`shares[${i}][email]`, schedule.shares[i].email);
            fd.append(`shares[${i}][mode]`, schedule.shares[i].mode);
        }
    }
    if (schedule.date_object) {
        fd.append("date_object[type]", schedule.date_object.type);
        if (schedule.date_object.data) {
            for (const prop in schedule.date_object.data) {
                if (prop === "dates") {
                    let dates = schedule.date_object.data.dates;
                    for (let i = 0; i < dates.length; i++) {
                        fd.append(`date_object[data][${prop}][${i}]`, dates[i]);
                    }
                } else {
                    fd.append(
                        `date_object[data][${prop}]`,
                        schedule.date_object.data[prop]
                    );
                }
            }
        }
    }
    if (schedule.attendee_object) {
        fd.append("attendee_object[type]", schedule.attendee_object.type);
        if (schedule.attendee_object.data) {
            for (const prop in schedule.attendee_object.data) {
                fd.append(
                    `attendee_object[data][${prop}]`,
                    schedule.attendee_object.data[prop]
                );
            }
        }
    }
    if (schedule.activities) {
        schedule.activities.forEach((activity, index) => {
            fd.append(`activities[${index}][type]`, activity.type);
            fd.append(`activities[${index}][start]`, activity.start);
            fd.append(`activities[${index}][duration]`, activity.duration);
            for (const prop in activity.data) {
                fd.append(
                    `activities[${index}][data][${prop}]`,
                    activity.data[prop]
                );
            }
        });
    }
    if (schedule.gifts && schedule.gifts.length > 0) {
        schedule.gifts.forEach((gift, index) => {
            fd.append(`gifts[${index}][type]`, gift.type);
            fd.append(
                `gifts[${index}][data][external_id]`,
                gift.data.external_id
            );
            fd.append(
                `gifts[${index}][data][external_type]`,
                gift.data.external_type
            );
        });
    }

    return fd;
}
